module.exports = __webpack_public_path__ + "static/media/play.8309114f.svg";